<template>
  <BaseButton primary outline class="w-full" @click="addMedia"> Add Media </BaseButton>
</template>

<script>
export default {
  inject: ['refreshAccProductTemplate'],
  props: {
    accProductTemplateId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async addMedia() {
      this.$modal.show({
        component: () => import('./AddMediaModal.vue'),
        props: {
          accProductTemplateId: this.accProductTemplateId,
        },
        on: {
          saved: () => {
            this.refreshAccProductTemplate();
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
